import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const FIRST_IMAGE = "https://customer-assets.emergentagent.com/job_music-doc-staging/artifacts/juv50yh0_Screenshot%202026-04-05%20at%2021.37.35.png";
const SECOND_IMAGE = "https://customer-assets.emergentagent.com/job_music-doc-staging/artifacts/f56k8xva_A-382651-1511203728-9962.jpg";

// Standardized text height for all screens
const TEXT_HEIGHT = "min-h-[200px] md:min-h-[250px]";

const TextBlock = ({ overline, text, refProp }) => {
  const { scrollYProgress } = useScroll({
    target: refProp,
    offset: ["start 0.9", "end 0.1"],
  });

  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);

  return (
    <motion.div
      ref={refProp}
      className={`${TEXT_HEIGHT} flex items-center justify-center px-6 sm:px-12 md:px-24 py-8`}
      style={{ opacity }}
    >
      <div className="w-full max-w-3xl text-center">
        <span className="font-mono text-[10px] sm:text-xs tracking-[0.2em] text-[#888888] uppercase block mb-4 sm:mb-6">
          {overline}
        </span>
        <p className="font-heading text-xl sm:text-2xl md:text-3xl lg:text-4xl font-light tracking-tight leading-relaxed text-[#F5F5F0]">
          {text}
        </p>
      </div>
    </motion.div>
  );
};

const ImageBlock = ({ src, alt, refProp, objectPosition = "center 30%" }) => {
  const { scrollYProgress } = useScroll({
    target: refProp,
    offset: ["start end", "end start"],
  });

  const opacity = useTransform(scrollYProgress, [0.1, 0.3, 0.7, 0.9], [0, 1, 1, 0]);
  const scale = useTransform(scrollYProgress, [0.1, 0.3, 0.7, 0.9], [0.95, 1, 1, 0.98]);

  return (
    <motion.div
      ref={refProp}
      className="min-h-[60vh] md:min-h-[80vh] flex items-center justify-center px-0"
      style={{ opacity, scale }}
    >
      <div className="film-frame w-full">
        <img
          src={src}
          alt={alt}
          className="gallery-image rounded-sm shadow-2xl"
          style={{ objectPosition }}
          loading="lazy"
        />
      </div>
    </motion.div>
  );
};

const IntroSection = () => {
  const text1Ref = useRef(null);
  const image1Ref = useRef(null);
  const text2Ref = useRef(null);
  const image2Ref = useRef(null);

  return (
    <section className="bg-[#050505]" data-testid="intro-section">
      {/* The Mission */}
      <TextBlock
        refProp={text1Ref}
        overline="The Mission"
        text="A film dedicated to preserving one of America's most historic recording studios."
      />

      {/* First Image */}
      <ImageBlock
        refProp={image1Ref}
        src={FIRST_IMAGE}
        alt="United Sound Systems"
        objectPosition="center 40%"
      />

      {/* United Sound Systems */}
      <TextBlock
        refProp={text2Ref}
        overline="United Sound Systems"
        text="United Sound Systems in Detroit, a cultural landmark that helped shape the sound of legends."
      />

      {/* Second Image - studio photo */}
      <ImageBlock
        refProp={image2Ref}
        src={SECOND_IMAGE}
        alt="Recording session at United Sound Systems"
        objectPosition="center 38%"
      />
    </section>
  );
};

export default IntroSection;
